const SHOW_LOADING = 'SHOW_LOADING';
const HIDE_LOADING = 'HIDE_LOADING';

export default {
	SHOW_LOADING,
	HIDE_LOADING
};
